import React from 'react'
import '../../styles/_components/_text/_header_text.scss'

export const HeaderText = ({text}) => {
    return(
        <p className="c-header_text">{text}</p>
    )
}